import React from "react";
import "./style.css";
import { logotext } from "../content_option";

const Footer = () => (
  <footer className="site__footer">
    <div className="site__footer-inner">
      <a className="site__footer-brand" href="#home">
        <span>{logotext}</span>
        <span className="site__footer-role">Video editor & visual storyteller</span>
      </a>
      <p className="site__footer-copy">© {new Date().getFullYear()} Hamza Zahid</p>
      <a className="site__footer-top" href="#home">
        Back to top <span aria-hidden="true">↑</span>
      </a>
    </div>
  </footer>
);

export default Footer;
